<template>
  <div>
    <div class="merchant-profile" v-if="pageType === 2">
      <!-- 头部标题 -->
      <h2 class="profile-title"></h2>

      <!-- 基本信息卡片 -->
      <el-card class="profile-card">
        <div class="info-section">
          <h3 class="section-title">基本信息</h3>
          <el-row :gutter="20">
            <el-col :span="10">
              <div class="info-item">
                <!-- <span class="info-label"> </span> -->
                <span class="info-value">{{ qiye_info.qiye_bianhao }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-item">
                <!-- <span class="info-label"> </span> -->
                <span class="info-value">{{ qiye_info.qiye_name }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-item">
                <!-- <span class="info-label"> </span> -->
                <span class="info-value">{{ qiye_info.qiye_mob }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <div class="info-item">
                <!-- <span class="info-label"> </span> -->
                <span class="info-value">{{ qiye_info.qiye_addr }}</span>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 操作按钮 -->
        <div class="action-buttons">
          <el-button type="primary" @click="logout">退出登陆</el-button>
          <!-- <el-button @click="handleRefresh">刷新数据</el-button> -->
        </div>
      </el-card>
    </div>

    <div class="order-page" @scroll="handleScroll" v-if="pageType === 0 || pageType === 1">
      <div class="noInfo" v-if="!productList">暂时没有订单可以操作</div>
      <el-form>
        <!-- 订单卡片 -->
        <div class="order-card" v-for="order in productList" :key="order.id">
          <!-- 订单标题与状态 -->
          <div class="order-header">
            <h3>{{ order.pro_name }}</h3>
            <div class="status">
              <el-tag type="success" v-if="order.queren_flag === 0" class="right"> 待抢单 </el-tag>
              <el-tag type="success" v-if="order.queren_flag === 1" class="right"> 已抢单 </el-tag>
              <el-tag type="success" v-if="order.queren_flag === 2" class="right"> 已完成 </el-tag>

              <el-tag :type="isExpired(order) ? 'info' : 'success'" v-if="order.queren_flag !== 2" class="right">
                {{ isExpired(order) ? '已过期' : '进行中' }}
              </el-tag>
            </div>
          </div>

          <div class="order-header02">名称: {{ order.guest_name }}</div>
          <div class="order-header02">电话: {{ order.guest_mob_mi }}</div>
          <div class="order-header02">地址: {{ order.guest_addr_mi }}</div>
          <!-- 订单详情与价格 -->
          <div class="order-content">
            <p class="order-detail">{{ order.pro_memo }}</p>
            <div class="order-price">
              <span>价格：</span>
              <strong>¥{{ order.pro_price_shichang.toFixed(2) }}</strong>
            </div>
          </div>

          <!-- 时间信息 -->
          <div class="order-meta">
            <span><i class="el-icon-time">放单</i> {{ formatTime(order.add_time0) }}</span>
            <span><i class="el-icon-timer">截止</i> {{ formatTime(order.end_time0) }}</span>
          </div>

          <!-- 图片展示 -->
          <div class="order-images">
            <el-image v-for="(img, index) in order.images" :key="index" :src="img" :preview-src-list="order.images" fit="cover" class="order-image"></el-image>
          </div>

          <!-- 抢单按钮 -->
          <el-button type="primary" :disabled="isExpired(order) || order.queren_flag >= 1" @click="handleGrab(order)" class="grab-btn" >
            {{ order.queren_flag === 1 ? '已抢单' : '立即抢单' }}
          </el-button>

          <el-button type="primary" @click="uploadPic(order.uid, order.pro_name)" class="grab-btn" v-if="order.queren_flag === 1"> 更新图片 </el-button>
          <el-button type="primary" @click="orderQueren(order.uid)" class="grab-btn"  v-if="order.queren_flag === 1"> 订单确认 </el-button>
        </div>

        <!-- 加载提示 -->
        <div v-if="loading" class="loading-tip">
          <el-icon class="is-loading"><loading /></el-icon>
          加载中...
        </div>

        <!-- 图片预览对话框 -->
        <el-dialog v-model="previewVisible" :title="`订单图片预览 (${previewIndex + 1}/${previewImages.length})`" width="80%">
          <el-carousel :initial-index="previewIndex" @change="handleCarouselChange">
            <el-carousel-item v-for="(img, index) in previewImages" :key="index">
              <img :src="img" class="preview-image" />
            </el-carousel-item>
          </el-carousel>
        </el-dialog>

        <!-- 图片上传 -->
        <el-dialog :visible.sync="addDialogVisible" title="图片更新" width="100px">
          <el-form-item label="图片">
            <div class="showPicTitle">当前内容：序号：{{ selectProduct.product_uid }} | 标题： {{ selectProduct.product_name }}</div>
            <div style="height: 100%" class="pics">
              <picUpload ref="picUploadRef" @backPicUrl="backPicUrl" show_type="3" :picsUrl="this.editForm.product_pics" :key="datekey"></picUpload>
              <div class="update_key"><el-button type="primary" @click="updateToBase" class="grab-btn02"> 确定 </el-button><el-button type="primary" @click="addDoalogClosed" class="grab-btn02"> 关闭 </el-button></div>
            </div>
          </el-form-item>
        </el-dialog>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Loading } from '@element-plus/icons-vue'
import picUpload from '../tongyong/pic_com.vue'
let count = 1
export default {
  components: { picUpload: picUpload },
  //  props: ['page_type'], // 页面类型  0 是抢单 1 是浏览 2 是商户资料
  data() {
    return {
      // noInfoShow: false,
      addDialogVisible: false,
      showFlag: true,
      selectProduct: {
        product_uid: 0,
        product_name: ''
      }, // 选中的产品uid
      upload_flag: 0,
      upload_key_flag: 0,
      datekey: Date.now(),
      editForm: {
        product_uid: 0,
        product_pics: ''
      },
      merchant: {
        name: '鲜果时光水果店',
        phone: '13800138000',
        address: '北京市朝阳区建国路88号华贸中心3号楼B1层',
        orderCount: 1285,
        registerTime: '2020-05-15T10:00:00'
      },
      pageType: 0,
      productList: [],
      qiye_info: '',
      queryInfo: {
        C_type: 'get_list_more',
        C_table_name: 'product_list_qd',
        query: '',
        pageNum: 1,
        pageSize: 10,
        qiye_uid: 0
      },

      query_qiye: {
        C_type: 'qiye_info',
        qiye_uid: this.qiye_uid
      },
      orders: [
        {
          id: '1',
          title: '家电维修订单',
          detail: '冰箱不制冷，需要更换压缩机，需携带R600a制冷剂',
          price: 299.99,
          createTime: '2025-07-20T10:00:00',
          expireTime: '2025-07-22T18:00:00',
          images: ['https://example.com/fridge1.jpg', 'https://example.com/fridge2.jpg', 'https://example.com/fridge3.jpg'],
          grabbed: false
        }
      ],
      qiye_uid: 0,
      loading: false,
      previewVisible: false,
      previewImages: [],
      previewIndex: 0,
      lastScrollTop: 0,
      isReachingBottom: false
    }
  },
  created() {
    // console.log(123, parseInt(window.sessionStorage.getItem('qiye_uid')))
    this.qiye_uid = parseInt(window.sessionStorage.getItem('qiye_uid'))
    this.getOrderList()
    this.getQiyeInfo() // 读取商户信息
  },
  methods: {
    orderQueren(orderUid) {
      this.$confirm('确认完成此订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        width: '150px', // 直接设置宽度
        type: 'warning'
      })
        .then(async () => {
          const productQiangUpdate = {
            C_type: 'product_update_qiang',
            product_uid: parseInt(orderUid),
            qiye_uid: this.qiye_uid,
            queren_flag: 2
          }
          const { data: res } = await this.$http.post('api', productQiangUpdate)
          this.$message.success('确认订单成功！')
          this.getOrderList()
        })
        .catch(() => {})
    },
    addDoalogClosed() {
      this.addDialogVisible = false
      this.$refs.picUploadRef.clearUpload()
      this.$refs.picUploadRef.show_pics = [] // 添加部分
      this.$refs.picUploadRef.addForm.pics = [] // 显示部分
    },
    uploadPic(uid, proName) {
      this.upload_flag = 1
      this.upload_key_flag = 1
      this.selectProduct.product_uid = uid
      this.selectProduct.product_name = proName
      this.addDialogVisible = true
    },
    backPicUrl(pics) {
      this.editForm.product_pics = pics
      this.pics = pics
      // console.log(9981, pics)x
      // 上传一张更新一张照片
    },

    async updateToBase() {
      const pic = {
        C_type: 'updateProductPic',
        product_uid: this.selectProduct.product_uid,
        qiye_uid: this.qiye_uid,
        product_pics: this.pics
      }
      const { data: res } = await this.$http.post('api', pic)
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('上传失败')
      } else {
        // 更新页面和标记
        this.addDoalogClosed()
        this.addDialogVisible = false
        this.getOrderList() // 刷新页面
      }
    },

    formatDate(timestamp) {
      return new Date(timestamp).toLocaleString()
    },
    handleEdit() {
      this.$message.info('进入编辑模式')
      // 实际项目中这里会跳转到编辑页面或打开编辑对话框
    },
    handleRefresh() {
      this.$message.success('数据已刷新')
      // 实际项目中这里会调用API重新获取数据
    },
    setPage(type) {
      this.pageType = type // 页面类型  0 是抢单 1 是浏览 2 是商户资料
      if (type < 2) {
        // 显示抢单大厅 ,2个页面，1个是订单一览，一个是资料一览。 ---订单
        this.queryInfo.C_table_name = type === 0 ? 'product_list_qd' : 'product_list_qd_my'
        this.getOrderList()
      }
    },
    async getOrderList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      })
      console.log(998, JSON.parse(res.data)[0].dataList)
      this.productList = JSON.parse(res.data)[0].dataList

      if (!this.productList) return
      this.productList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1
        // 对图片字符串进行处
        item.images = item.product_pics.split(',')
        item.images.length -= 1 // 舍弃最后一个元素
      })
      console.log(9999, this.productList)
      // this.total = JSON.parse(res.data)[0].total
      // console.log((this.total === 0), 8889, this.total)
      // this.noInfoShow = (this.total === 0)
    },
    async getQiyeInfo() {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'qiye_info', uid: this.qiye_uid, C_type: 'get_info' }
      })
      // console.log(JSON.parse(res.data))
      console.log(res.data)
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败')
      }
      this.qiye_info = JSON.parse(res.data)[0].data[0]
      // const { data: res } = await this.$http.get('get_api', {
      //   params: this.query_qiye
      // })
      // this.qiye_info = JSON.parse(res.data)[0].dataList
    },
    formatTime(timestamp) {
      return new Date(timestamp).toLocaleString()
    },
    isExpired(order) {
      return new Date() > new Date(order.end_time0)
    },
    handleGrab(order) {
      this.$confirm(`确认以¥${order.pro_price_shichang.toFixed(2)}抢此订单吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        width: '150px', // 直接设置宽度
        type: 'warning'
      })
        .then(async () => {
          const productQiangUpdate = {
            C_type: 'product_update_qiang',
            product_uid: parseInt(order.uid),
            qiye_uid: this.qiye_uid,
            queren_flag: 1
          }

          const { data: res } = await this.$http.post('api', productQiangUpdate)
          console.log(JSON.parse(res.data)[0].bianhao_s)

          order.grabbed = true
          this.$message.success('抢单成功！')
          this.getOrderList()
        })
        .catch(() => {})
    },
    showPreview(images, index = 0) {
      this.previewImages = images
      this.previewIndex = index
      this.previewVisible = true
    },
    handleCarouselChange(index) {
      this.previewIndex = index
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      const scrollHeight = event.target.scrollHeight
      const clientHeight = event.target.clientHeight

      // 向下滚动时触发
      if (scrollTop > this.lastScrollTop) {
        // 距离底部50px时加载更多
        if (scrollHeight - (scrollTop + clientHeight) < 50 && !this.loading && !this.isReachingBottom) {
          this.loadMore()
        }
      }
      this.lastScrollTop = scrollTop
    },
    loadMore() {
      this.loading = true
      this.isReachingBottom = true

      // 模拟异步加载
      setTimeout(() => {
        // this.orders.push({
        //   id: '3',
        //   title: '新增订单-' + (this.orders.length + 1),
        //   detail: '这是通过下拉加载新增的订单',
        //   price: 159.99,
        //   createTime: new Date().toISOString(),
        //   expireTime: new Date(Date.now() + 86400000 * 2).toISOString(),
        //   images: ['https://example.com/new1.jpg', 'https://example.com/new2.jpg', 'https://example.com/new3.jpg'],
        //   grabbed: false
        // })
        // 更新数据
        count++
        this.queryInfo.pageSize = 10 * count // 每个页面 记录数量
        console.log(111, this.queryInfo)
        this.getOrderList()
        this.loading = false
        this.isReachingBottom = false
        console.log(123)
      }, 1000)
    },
    logout() {
      // if (window.sessionStorage.getItem('tokenUserType') === 1) this.$router.replace('../Admin');
      // if (window.sessionStorage.getItem('tokenUserType') === 2) this.$router.replace('../Login');

      //  console.log((window.sessionStorage.getItem('tokenUserType') === '2'))
      if (window.sessionStorage.getItem('tokenUserType') === '3') this.$router.replace('../mob')
      this.$store.commit('delete_all')
      window.sessionStorage.clear()
    }
  },
  mounted() {
    // 初始化滚动容器
    const container = this.$el
    container.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    const container = this.$el
    container.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.order-page {
  height: 100vh;
  overflow-y: auto;
  padding: 20px;
  background-color: #f5f7fa;
  /* display: flex;
  flex-direction: column;
  justify-self: center; */
}

.order-card {
  background: white;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.order-header02 {
  width: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
}

.order-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.order-content {
  margin: 12px 0;
  font-size: 14px;
}

.order-detail {
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}

.order-price {
  font-size: 16px;
  color: #ff5722;
}

.order-price strong {
  font-size: 18px;
}

.order-meta {
  display: flex;
  justify-content: space-between;
  color: #999;
  font-size: 14px;
  margin: 12px 0;
}

.order-images {
  display: flex;
  gap: 10px;
  margin: 12px 0;
}

.order-image {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  cursor: pointer;
}

.grab-btn {
  width: 90px;
  margin-top: 12px;
  padding: 12px;
}
.grab-btn02 {
  width: 80px;
  margin-top: 12px;
  padding: 12px;
}
.loading-tip {
  text-align: center;
  padding: 20px;
  color: #999;
}

.preview-image {
  max-width: 100%;
  max-height: 60vh;
  display: block;
  margin: 0 auto;
}

.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  display: flex;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}
.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 12px;
}
.tab-item.active {
  color: #42b983; /* 激活态颜色 */
}
.tab-item i {
  font-size: 20px;
  margin-bottom: 3px;
}
.merchant-profile {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.profile-title {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.profile-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.info-section {
  margin-bottom: 20px;
  padding: 15px;
  border-bottom: 1px solid #eee;
}

.section-title {
  margin-bottom: 15px;
  color: #409eff;
  font-size: 16px;
}

.info-item {
  margin-bottom: 10px;
  line-height: 1.6;
}

.info-label {
  font-weight: bold;
  color: #666;
  min-width: 80px;
  display: inline-block;
}

.info-value {
  color: #333;
}

.action-buttons {
  text-align: center;
  margin-top: 20px;
}
.update_key {
  text-align: center;
  background-color: #fff;
}
.pics {
  background-color: #fff;
}
.showPicTitle {
  text-align: left;
}
.noInfo {
  text-align: center;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.status {
  display: flex;
  width: 120px;
}
.right {
  margin-left: auto; /* 这个元素会靠右 */
}
.test{
   width: 300px;
  
}
</style>
